import styled from '@emotion/styled'
import { Grid } from '@mui/material'
import { theme as newTheme } from 'styles/theme/hav-theme'

export const RowColumnTableItemsOrderStyled = styled(Grid)`
  width: 100%;
`

export const ContentDivider = styled.div`
  height: ${newTheme.spacing.md};
  width: 100%;
`

export const LoadingContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  border-radius: ${newTheme.shapes.borderRadius.sm};
  background-color: ${newTheme.colors.neutral['100']};
  height: 312px;
`
